import React, {useState} from "react";
import {AdminNavbarList} from "./AdminNavbarList";
import {AdminNavbarListItem} from "./AdminNavbarListItem";
import {HamburgerButton} from "../shared";
import {adminNavbarItemsData} from "../../configs";
import {SignOutButton} from "./SignOutButton";
import {useAuth} from "../AuthContext";
import {roleAccessMap} from "../../variables/roleAccessMap";

const AdminNavbar: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const {userRole} = useAuth();

    const filteredNavbarItems = adminNavbarItemsData.filter(item => {
        const allowedRoles: string[] | undefined = roleAccessMap[item.path];
        return allowedRoles?.includes(userRole);
    });

    return (
        <nav className="bg-gray-800 text-white top-0 w-full z-50 sticky">
            <div className="lg:container mx-auto flex items-center p-4 relative">
                <div className="text-xl font-bold whitespace-nowrap">KČT Administrace</div>
                <div className="hidden lg:flex ml-auto">
                    <AdminNavbarList isOpen={true}>
                        {filteredNavbarItems.map((item, index) => (
                            <AdminNavbarListItem key={index} item={item} setIsOpen={setIsOpen}/>
                        ))}
                    </AdminNavbarList>
                    <SignOutButton isOpen={isOpen}/>
                </div>

                <div className="ml-auto lg:hidden">
                    <HamburgerButton isOpen={isOpen} setIsOpen={setIsOpen}/>
                </div>

                <div className="absolute top-full left-0 w-full lg:hidden">
                    <AdminNavbarList isOpen={isOpen}>
                        {filteredNavbarItems.map((item, index) => (
                            <AdminNavbarListItem key={index} item={item} setIsOpen={setIsOpen}/>
                        ))}
                    </AdminNavbarList>
                    <SignOutButton isOpen={isOpen}/>
                </div>

            </div>
        </nav>
    );
};

export default AdminNavbar;
